import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { usePageTitle } from '../shared/navigation/page-title';
import { ButtonLink } from '../shared/ui/button';
import { EmptyState } from '../shared/ui/empty-state';
import { PageHeading } from '../shared/ui/page-heading';

export const NotFoundPage = () => {
  const { t } = useTranslation();
  const { locale } = useParams();
  usePageTitle(t('errors.notFound'));
  return (
    <div className="space-y-6">
      <PageHeading title={t('errors.notFound')} />
      <EmptyState
        title={t('errors.notFoundDescription')}
        action={<ButtonLink to={`/${locale}/`}>{t('legal.back')}</ButtonLink>}
      />
    </div>
  );
};
